import { useTranslation } from 'react-i18next';
import { css } from '@emotion/react';
import { TableV2 } from '@anytag/shared-atoms';
import { THEME } from '@anytag/shared-constants';
import { TiktokAdAccountInfo } from '@anytag/graphql';
import { useBudgetAllocationTable } from './useBudgetAllocationTable';

interface BudgetAllocationTableProps {
  data: readonly TiktokAdAccountInfo[];
  loading: boolean;
  prepaidBalance: number;
}
export const BudgetAllocationTable = ({ data, loading, prepaidBalance }: BudgetAllocationTableProps) => {
  const { t } = useTranslation();
  const { columns } = useBudgetAllocationTable({ prepaidBalance });

  return (
    <TableV2 data={data} columns={columns} skipNoDataNode>
      {data.length === 0 && !loading ? <div css={styles.emptyTable}>{t('No Data')}</div> : null}
    </TableV2>
  );
};

const styles = {
  emptyTable: css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '48px',
    backgroundColor: THEME.background.colors.white,
    borderRadius: '0 0 3px 3px',
    boxShadow: THEME.shadows.boxShadow,
    color: THEME.text.colors.gray.lv3
  })
};
